import { Table } from "react-bootstrap";
import type { RestrictionAdjustmentData } from "../lib/explainTypes";

interface Props {
  restrictions: RestrictionAdjustmentData | null;
}

export default function RestrictionsSection({ restrictions }: Props) {
  if (!restrictions || restrictions.restrictions.length === 0) {
    return <div className="text-muted">No restrictions.</div>;
  }
  return (
    <Table size="sm">
      <thead>
        <tr>
          <th>Symbol</th>
          <th>Type</th>
          <th className="text-end">Locked weight</th>
          <th>Source</th>
        </tr>
      </thead>
      <tbody>
        {restrictions.restrictions.map((r) => (
          <tr key={r.symbol}>
            <td>{r.symbol}</td>
            <td>{r.type}</td>
            <td className="text-end">{r.locked_weight}</td>
            <td>{r.source}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
